<div class="default-container max-width">
    <h1 class="h3-size txt-trns-upper clr-tertiary-3 font-bold m-b-1-5 aln-center">Accessibility Statement</h1>
    <div class="home-container">
        <p class="m-t-0">
            FracFocus and the Ground Water Protection Council (hereafter GWPC) are dedicated to supporting a
            welcoming, inclusive, and accessible workplace and environment for all.
        </p>
        <p>
            Our ongoing accessibility efforts work towards meeting the Web Content Accessibility Guidelines (WCAG)
            version 2.1, levels A and AA criteria. These guidelines not only help make web content accessible to
            users with sensory, cognitive, and mobility disabilities but ultimately to all users, regardless of
            ability.
        </p>
        <p>
            This website is just part of a meaningful change in making FracFocus' services inclusive and accessible.
            FracFocus and GWPC welcomes requests for accommodation and comments on how to improve the accessibility
            of this website for users with disabilities. Please contact us if you encounter any accessibility
            barriers. We strive to respond within five business days.
        </p>
        <p class="accessibility-contact">
            Phone: <span class="accessibility-contact-value">405-516-4972</span><br>
            Address: <span class="accessibility-contact-value">13308 N. MacArthur Blvd.<br>Oklahoma City, OK 73142</span>
        </p>
        <h2 class="h4-size clr-tertiary-3 font-bold">Accessibility evaluation</h2>
        <p>
            Technology is constantly evolving, and new techniques to implement web accessibility are increasingly
            available. We will continue to review our website and apply additional accessibility as needed.
        </p>
        <p><i>Updated: July 20, 2026</i></p>
    </div>
</div>
